import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

interface CancelLoteModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (razaoCancelamento: string) => void;
}

const CancelLoteModal: React.FC<CancelLoteModalProps> = ({ show, onHide, onSubmit }) => {
  const [razaoCancelamento, setRazaoCancelamento] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleSubmit = () => {
    setShowConfirmModal(true);
  };

  const handleConfirm = () => {
    onSubmit(razaoCancelamento);
    setShowConfirmModal(false);
    onHide();
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
  };

  return (
    <>
      <Modal
        show={show} 
        onHide={onHide}
        className="hana-modal"
        centered
      >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="hana-modal-title">
          Cancelar Lote 
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-4">
        <div className="hana-form-group mb-4">
          <label className="hana-label mb-2">Razão do Cancelamento</label>
          <input
            type="text"
            className="form-control hana-input"
            placeholder="Digite a razão do cancelamento"
            maxLength={30}
            value={razaoCancelamento}
            onChange={e => setRazaoCancelamento(e.target.value)}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        <Button 
          variant="outline-secondary" 
          className="hana-button me-2"
          onClick={onHide}
        >
          Fechar
        </Button>

        <Button
          variant="primary" 
          className="hana-button-primary"
          onClick={handleSubmit}
          disabled={razaoCancelamento.length === 0}
        >
          Confirmar Cancelamento
        </Button>
      </Modal.Footer>
    </Modal>

    {/* Modal de Confirmação */}
    <Modal 
      show={showConfirmModal} 
      onHide={handleCancel}
      className="hana-modal"
      centered
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="hana-modal-title">
          Confirmar Cancelamento
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-4">
        <p className="mb-0">
          Tem certeza que deseja cancelar o lote? Após o cancelamento, todos os dados do lote serão perdidos.
        </p>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        <Button 
          variant="outline-secondary" 
          className="hana-button me-2"
          onClick={handleCancel}
        >
          Fechar
        </Button>

        <Button 
          variant="primary" 
          className="hana-button-primary"
          onClick={handleConfirm}
        >
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default CancelLoteModal; 